<template>
	<div>
		<NavBar></NavBar>
		<Banner></Banner>
		<Game></Game>
		<Footer></Footer>
	</div>
</template>

<script>
	import NavBar from '../components/NavBar/NavBar.vue'
	import Banner from '../components/Banner/Banner.vue'
	import Game from '../components/Game/Game.vue'
	import Footer from '../components/Footer/Footer.vue'
	export default{
		components:{
			NavBar,
			Banner,
			Footer,
			Game
		}
	}
</script>

<style>
</style>
